import { render, staticRenderFns } from "./PrintPortrait.vue?vue&type=template&id=8e0c45f8"
import script from "./PrintPortrait.vue?vue&type=script&lang=ts"
export * from "./PrintPortrait.vue?vue&type=script&lang=ts"
import style0 from "./PrintPortrait.vue?vue&type=style&index=0&id=8e0c45f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports